import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "form", "detail", "configInput" ]

  connect() {
    // console.log("Hello, Entity Team Trends Controller here!", this.element);
    // console.log(this.detailTargets);
  }

  toggleDetails(event) {
    console.log("toggleDetails", event.currentTarget.dataset.trendKey);
    console.log(this.detailTargets);

    this.detailTargets.forEach(detail => {
      if (detail.dataset.trendKey === event.currentTarget.dataset.trendKey) {
        if (detail.classList.contains("d-none")) {
          detail.classList.remove("d-none");
          detail.classList.add("d-block");
        } else {
          detail.classList.remove("d-block");
          detail.classList.add("d-none");
        }
      } else {
        detail.classList.remove("d-block");
        detail.classList.add("d-none");
      }
    });


  }

  attemptSubmit(event) {
    event.preventDefault();

    // console.log("attemptSubmit", event.currentTarget.dataset.action);

    // Group config inputs by trend config index
    const configInputs = this.configInputTargets;
    const trendConfigs = {};

    configInputs.forEach(function(input) {
      // debugger;

      const trendKey = input.dataset.trendKey;
      const statKey = input.dataset.statKey;
      const value = input.value.trim();
      const defaultValue = input.dataset.defaultValue;

      // Find the parent trend config form
      const trendForm = input.closest('[name*="entity_team_trend_configs"]');
      if (!trendForm) return;

      // Extract the index from the form name (e.g., "entity_team[entity_team_trend_configs_attributes][0]")
      // const formName = trendForm.getAttribute('name');
      // const match = formName.match(/\[(\d+)\]/);
      // if (!match) return;

      //  const index = match[1];
       const index = input.dataset.index;
       const configKey = `${index}_${trendKey}`;

       // Only add to config if value is not empty and different from default
       if (value !== '' && value !== defaultValue) {
         if (!trendConfigs[configKey]) {
           trendConfigs[configKey] = {};
         }
         trendConfigs[configKey][statKey] = value;
       }
     });

    //  console.log(trendConfigs);
    //  debugger;

     // Update the config hidden fields for each trend
     Object.keys(trendConfigs).forEach(function(configKey) {
       const [index, _] = configKey.split('_', 2);
       const configInput = document.querySelector(`input[name="entity_team[entity_team_trend_configs_attributes][${index}][config]"]`);
       if (configInput) {
         configInput.value = JSON.stringify(trendConfigs[configKey]);
       }
     });

     // Remove the individual config_* fields to prevent them from being submitted
     configInputs.forEach(function(input) {
       input.removeAttribute('name');
     });

     this.formTarget.submit();
  }

}
